import React, { Fragment ,useContext,useState, useEffect, useRef } from 'react';
import classNames                 from 'classnames';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PropTypes                  from 'prop-types';
import { connect } from 'react-redux'
import store from 'store'
import { findMenuKeyByPathNew } from '../../../../services/menu/index';

import { map } from 'lodash';

/*
| UI
*/
import { Menu, Layout, Skeleton, Tooltip, Button, Dropdown, Space, Typography, Alert, Spin, Badge, Card, Tag, Switch, Segmented } from 'antd';
import { capitalize } from 'helpers/utils';

import { DownOutlined  , MenuOutlined} from '@ant-design/icons';

/*
| Icons
*/
import { UsergroupAddOutlined, PlusOutlined, HomeOutlined, SettingOutlined, UserOutlined, CrownOutlined, BulbOutlined, ExperimentOutlined, ToolOutlined, LayoutOutlined } from '@ant-design/icons'
import { FcCalculator, FcContacts, FcAddressBook, FcCurrencyExchange, FcFeedIn } from "react-icons/fc";
import { PiMathOperationsDuotone, PiPlusMinusDuotone, PiUserPlusDuotone, PiReceiptDuotone } from "react-icons/pi"; 


/*
| PAGES
*/

import AuthContext from '../../../../context/authProvider';
import AppContext from '../../../../context/Context';
import { PAGE_CONTAINER_MODE } from '../../../../config';
import { usePrivileges } from 'helpers/license/usePermissions';

import Flex                       from '../../../common/Flex'

import Logo from '../../Logo';
import VarexeLogo from 'components/common/VarexeLogo';


// import permissionsService from '../../../permissions/services/index'
import { all, put, call } from 'redux-saga/effects'

// Import CSS for enhanced styling
import './NavbarLeft.css';

const mapStateToProps = ({  settings, auth, menu }) => ({
  menuData: menu.menuData,
  menuLoading: menu.loading,
  menuError: menu.error,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
  // role: user.role,
})

const NavbarLeft = ({
  dispatch,
  menuData = [],
  menuLoading = true,
  menuError = null,
  // location: { pathname },

  isMenuCollapsed,
  isMobileView,
  isMobileMenuOpen,
  isMenuUnfixed,
  isMenuShadow,
  leftMenuWidth,
  menuColor,
  logo,
  // role,
}) => {

  // Get user permissions from AuthContext
  const { auth } = useContext(AuthContext);
  const {
    config: { developerMode, isDark, showFooterTools, pageContainerMode },
    setConfig,
  } = useContext(AppContext);
  const { license_status } = usePrivileges();
  const userPermissions = auth?.user?.extra?.privileges?.permissions || [];

  const handleTestModeChange = (checked) => {
    setConfig('developerMode', checked);
    setTimeout(() => window.location.reload(), 500);
  };
  const handleThemeChange = (checked) => {
    setConfig('isDark', checked);
  };
  const handleFooterToolsChange = (checked) => {
    setConfig('showFooterTools', checked);
  };

  // let menuData = [];

  const [selectedKeys, setSelectedKeys] = useState(store.get('app.menu.selectedKeys') || [])
  const [openedKeys, setOpenedKeys] = useState(store.get('app.menu.openedKeys') || [])
  const [isLoading, setIsLoading] = useState(false)

  // const [isuser_roleLoading, setIsuser_role] = useState(true);


  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Helper to normalize paths for comparison
  const normalizePath = (path) => {
    if (!path) return '';
    // Remove trailing slashes and ensure leading slash
    return '/' + path.replace(/^\/+|\/+$/g, '').replace(/\/+/g, '/');
  };

  // Helper to get path segments (e.g., '/invoices/list' -> ['invoices', 'list'])
  const getPathSegments = (path) => {
    if (!path) return [];
    return path.split('/').filter(p => p && !p.match(/^:/)); // Filter out route params like :id
  };

  // Check if current path matches a menu item path
  const pathMatches = (itemPath, currentPath) => {
    if (!itemPath || !currentPath) return false;
    
    const normalizedItemPath = normalizePath(itemPath);
    const normalizedCurrentPath = normalizePath(currentPath);
    
    // 1. Exact match (highest priority)
    if (normalizedItemPath === normalizedCurrentPath) {
      return { match: true, specificity: 100 };
    }
    
    // 2. Current path starts with item path + '/' (e.g., /invoices/list matches /invoices/list/123)
    // This handles detail pages under a list route
    if (normalizedCurrentPath.startsWith(normalizedItemPath + '/')) {
      return { match: true, specificity: 80 };
    }
    
    // 3. Check if they share path segments
    const itemSegments = getPathSegments(itemPath);
    const currentSegments = getPathSegments(currentPath);
    
    if (itemSegments.length > 0 && currentSegments.length > 0) {
      // Count how many segments match from the start
      let matchingSegments = 0;
      for (let i = 0; i < Math.min(itemSegments.length, currentSegments.length); i++) {
        if (itemSegments[i] === currentSegments[i]) {
          matchingSegments++;
        } else {
          break;
        }
      }
      
      // If first segment matches, they're in the same section
      if (matchingSegments > 0) {
        // If item is a list page and current path is in the same section, match it
        // e.g., /invoices/list matches /invoices/new, /invoices/invoice-details/123, etc.
        const isListPage = itemSegments[itemSegments.length - 1] === 'list';
        if (isListPage && matchingSegments >= 1) {
          return { match: true, specificity: 60 + (matchingSegments * 5) };
        }
        
        // If multiple segments match, it's a closer match
        if (matchingSegments > 1) {
          return { match: true, specificity: 40 + (matchingSegments * 10) };
        }
        
        // Single segment match (same section)
        return { match: true, specificity: 30 };
      }
    }
    
    return { match: false, specificity: 0 };
  };

  // Recursively find menu item key that matches the current pathname
  // Returns the most specific (highest specificity) match
  const findMenuItemKeyByPath = (items, currentPath, parentKeys = []) => {
    if (!items || !Array.isArray(items)) return null;
    
    let bestMatch = null;
    let bestSpecificity = 0;
    
    for (const item of items) {
      // Skip group items (they don't have paths, only children)
      const isGroup = item.type === 'group';
      
      // First, recursively check children to find more specific matches
      if (item.children && item.children.length > 0) {
        const childResult = findMenuItemKeyByPath(
          item.children, 
          currentPath, 
          isGroup ? parentKeys : [...parentKeys, item.key]
        );
        if (childResult && childResult.specificity > bestSpecificity) {
          bestMatch = childResult;
          bestSpecificity = childResult.specificity;
        }
      }
      
      // Skip path checking for groups
      if (isGroup) {
        continue;
      }
      
      // Get path from item.path property or try to extract from label Link component
      let itemPath = item.path;
      
      // Fallback: if path property doesn't exist, try to extract from Link component
      if (!itemPath && item.label && React.isValidElement(item.label)) {
        const findLinkPath = (element) => {
          if (!React.isValidElement(element)) return null;
          if (element.type === Link && element.props && element.props.to) {
            return element.props.to;
          }
          if (element.props && element.props.children) {
            const children = React.Children.toArray(element.props.children);
            for (const child of children) {
              const result = findLinkPath(child);
              if (result) return result;
            }
          }
          return null;
        };
        itemPath = findLinkPath(item.label);
      }
      
      if (itemPath) {
        const matchResult = pathMatches(itemPath, currentPath);
        
        if (matchResult.match && matchResult.specificity > bestSpecificity) {
          bestMatch = {
            key: item.key,
            parentKeys: parentKeys,
            specificity: matchResult.specificity,
            pathLength: itemPath.length
          };
          bestSpecificity = matchResult.specificity;
        }
      }
    }
    
    return bestMatch;
  };

  // Update selected keys when pathname changes
  useEffect(() => {
    if (!menuData || menuData.length === 0 || menuLoading) {
      return;
    }

    // Use new route-based path matching (all modules now migrated)
    const match = findMenuKeyByPathNew(pathname, menuData);
    
    // Debug logging (can be removed later)
    if (process.env.NODE_ENV === 'development') {
      // console.log('Menu path matching:', {
      //   pathname,
      //   match,
      //   usingNewSystem: !!findMenuKeyByPathNew(pathname, menuData),
      //   menuDataSample: menuData.slice(0, 2).map(item => ({ key: item.key, path: item.path }))
      // });
    }
    
    if (match) {
      const newSelectedKeys = [match.key];
      
      // Only update if different to avoid unnecessary re-renders
      if (JSON.stringify(selectedKeys) !== JSON.stringify(newSelectedKeys)) {
        store.set('app.menu.selectedKeys', newSelectedKeys);
        setSelectedKeys(newSelectedKeys);
      }
      
      // When menu is collapsed, don't auto-open submenus (they'll show as popups on hover)
      // When expanded, auto-open parent menus to show the selected item
      if (!isMenuCollapsed || isMobileView) {
        const newOpenedKeys = match.parentKeys;
        if (newOpenedKeys.length > 0) {
          const currentOpenedKeys = openedKeys || [];
          const shouldUpdate = newOpenedKeys.some(key => !currentOpenedKeys.includes(key));
          if (shouldUpdate) {
            const updatedOpenedKeys = [...new Set([...currentOpenedKeys, ...newOpenedKeys])];
            store.set('app.menu.openedKeys', updatedOpenedKeys);
            setOpenedKeys(updatedOpenedKeys);
          }
        }
      }
      // When collapsed, don't auto-open but allow hover to work
    } else if (process.env.NODE_ENV === 'development') {
      // console.warn('No menu match found for pathname:', pathname);
    }
  }, [pathname, menuData, menuLoading, isMenuCollapsed, isMobileView]);

  useEffect(() => {    
  }, [pathname, menuData, menuLoading, menuError, userPermissions])

  // Auto-load menu when permissions are available
  useEffect(() => {
    // console.log('Auto-load effect triggered:', {
    //   userPermissions: userPermissions.length,
    //   menuDataLength: menuData?.length || 0,
    //   menuLoading,
    //   isLoading,
    //   hasAuth: !!auth?.user
    // });
    
    // Simplified condition for debugging
    if (userPermissions.length > 0) {
      // console.log('Auto-loading menu with permissions:');
      // console.log('Auto-loading menu with permissions:', userPermissions);
      dispatch({
        type: 'menu/GET_DATA',
        payload: { 
          userPermissions,
          authContext: auth // Pass the entire auth context
        }
      });
    }
  }, [userPermissions, dispatch, auth]);

  // Manual trigger for testing
  const handleManualMenuLoad = () => {
    setIsLoading(true);
    dispatch({
      type: 'menu/GET_DATA',
      payload: { 
        userPermissions,
        authContext: auth // Pass the entire auth context
      }
    });
    // Simulate loading state for 2 seconds
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  // Generate skeleton menu items for loading state
  const generateSkeletonMenu = () => {
    const skeletonItems = [];
    for (let i = 0; i < 8; i++) {
      skeletonItems.push({
        label: <Skeleton.Input active  style={{ width: 250, height: 30, marginBottom: '30px' }}  />,
        key: `skeleton-${i}`,
      });
    }
    return skeletonItems;
  };

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  

  let time = null;


  const onCollapse = (value, type) => {
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
    setOpenedKeys([])
  }

  const onOpenChange = keys => {
    // Always update state - this is critical for hover to work when collapsed
    setOpenedKeys(keys)
    // Only persist to storage when expanded (not needed for hover popups)
    if (!isMenuCollapsed || isMobileView) {
      store.set('app.menu.openedKeys', keys)
    }
  }

  const handleClick = e => {
    store.set('app.menu.selectedKeys', [e.key])
    setSelectedKeys([e.key])
    
    // Close drawer on mobile when menu item is clicked
    if (isMobileView && isMobileMenuOpen) {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileMenuOpen',
          value: false,
        },
      })
    }
  }
  
  const menuSettings = isMobileView
    ? {
        width:leftMenuWidth,
        collapsible: false,
        collapsed: false,
        collapsedWidth: 0,
        // border: "solid 1px #000",
        onCollapse,      
      }
    : {
        width:leftMenuWidth,
        collapsible: true,
        collapsed: isMenuCollapsed,
        collapsedWidth: 80,
        // border: "solid 1px #000",
        onCollapse,
        breakpoint: 'lg',       
      } 

  // Render menu content based on loading state
  const renderMenuContent = () => {    
    // console.log('renderMenuContent called with:', {
    //   menuLoading,
    //   isLoading,
    //   hasAuth: !!auth?.user,
    //   menuDataLength: menuData?.length || 0,
    //   menuError: !!menuError
    // });
    
    // Show loading if either Redux loading state or local loading state is true
    if (menuLoading || isLoading) {
      // console.log('Showing skeleton menu - menuLoading:', menuLoading, 'isLoading:', isLoading);
      return (
        <Menu
          mode=""
          items={generateSkeletonMenu().map(item => ({
            ...item,
            style: {  width: '100%', margin: '30px 20px' } // Add margin bottom to each menu item
          }))}
          style={{ 
            border: 'none', 
            backgroundColor: 'transparent',
            padding: '0px 0px'
          }}
        />
      );
    }

    // Show loading if permissions are not yet available (auth context still loading)
    if (!auth || !auth.user) {
      // console.log('Showing skeleton menu - auth context loading');
      return (
        <Menu
          mode="inline"
          items={generateSkeletonMenu()}
          style={{ border: 'none', backgroundColor: 'transparent' }}
        />
      );
    }

    if (menuError) {
      // console.log('Showing error menu');
      return (
        <div className="p-3">
          <Alert
            title="Menu Error"
            description={menuError}
            type="error"
            showIcon
            size="small"
          />
          <Button onClick={handleManualMenuLoad} size="small" className="mt-2" loading={isLoading}>
            Retry Load Menu
          </Button>
        </div>
      );
    }

    // Only show "No Menu Items" if we're not loading and have no data
    if (!menuLoading && auth && (!menuData || menuData.length === 0)) {
      // console.log('Showing no menu items - menuData length:', menuData?.length);
      return (
        // <div className="p-3">
        //   <Alert
        //     title="No Menu Items"
        //     description="No menu items are available. Click the button below to load menu data."
        //     type="info"
        //     showIcon
        //     size="small"
        //   />
        //   <Button onClick={handleManualMenuLoad} size="small" className="mt-2" loading={isLoading}>
        //     Load Menu Data
        //   </Button>
        // </div>
        <Menu
          mode=""
          items={generateSkeletonMenu().map(item => ({
            ...item,
            style: {  width: '100%', margin: '30px 20px' } // Add margin bottom to each menu item
          }))}
          style={{ 
            border: 'none', 
            backgroundColor: 'transparent',
            padding: '0px 0px'
          }}
        />        
      );
    }

    // console.log('Showing actual menu with items:', menuData?.length);
    const isCollapsed = isMenuCollapsed && !isMobileView;
    
    return (
      <Menu
        onClick={handleClick}
        selectedKeys={selectedKeys}
        openKeys={openedKeys}
        onOpenChange={onOpenChange}
        mode="inline"
        inlineCollapsed={isCollapsed}
        items={menuData}
        style={{ border: 'none', backgroundColor: 'transparent' }}
        getPopupContainer={(triggerNode) => {
          // When collapsed, return body for proper popup positioning
          if (isCollapsed) {
            return document.body;
          }
          // When expanded, return sider container
          const sider = triggerNode?.closest('.ant-layout-sider');
          return sider || document.body;
        }}
        triggerSubMenuAction={isCollapsed ? 'hover' : 'click'}
        subMenuOpenDelay={isCollapsed ? 0.05 : 0}
        subMenuCloseDelay={isCollapsed ? 0.1 : 0}
      />
    );
  };

  return (
    <Layout.Sider
      trigger={null}
      {...menuSettings}
      className={classNames(`varexe-navbar-side ps-2`, {
        // 'white': menuColor === 'white',
        // 'gray': menuColor === 'gray',
        // 'dark': menuColor === 'dark',
        // 'unfixed': isMenuUnfixed,
        // 'shadow': isMenuShadow,
      })} 
      theme="dark"
      style={{
        padding: '0px 0px',
        overflow: 'hidden',
        height: '100%',
        '--sider-width': isMobileView ? '0px' : (isMenuCollapsed ? '80px' : `${leftMenuWidth}px`),
      }}
    >
      <div
        className="varexe-navbar-side__inner"
      >

        <div className={''} style={{ flexShrink: 0 }}>
          <div className={''}>
            {(isMenuCollapsed && !isMobileView ? 
              <VarexeLogo type={'svg'} style={{width:'30px', margin: '15px 15px 18px 25px'}}  className='fs-1'/>
              :
              <div style={{width:'238px', marginLeft: '5px'}} className=' mt-2 mb-3'>
                <div className=''>
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: 'test-mode',
                          icon: <ExperimentOutlined />,
                          label: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 12 }}
                            >
                              <span>Test mode</span>
                              <Switch
                                size="small"
                                checked={developerMode}
                                onChange={handleTestModeChange}
                                className="ant-switch-warning"
                                style={{ backgroundColor: developerMode ? '#CC4B00' : undefined }}
                              />
                            </div>
                          ),
                          onClick: (e) => e.domEvent.stopPropagation(),
                        },
                        { type: 'divider' },
                        {
                          key: 'dark-mode',
                          icon: <BulbOutlined />,
                          label: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 12 }}
                            >
                              <span>Dark mode</span>
                              <Switch
                                size="small"
                                // checkedChildren="Dark"
                                // unCheckedChildren="Light"
                                checked={isDark}
                                onChange={handleThemeChange}
                              />
                            </div>
                          ),
                          onClick: (e) => e.domEvent.stopPropagation(),
                        },

                        {
                          key: 'page-container-mode',
                          icon: <LayoutOutlined />,
                          label: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              style={{ width: '100%', minWidth: 200, maxWidth: 280 }}
                            >
                              <Typography.Text
                                type="secondary"
                                style={{ display: 'block', marginBottom: 8, fontSize: 12 }}
                              >
                                Page width
                              </Typography.Text>
                              <Segmented
                                size="small"
                                block
                                value={
                                  pageContainerMode === PAGE_CONTAINER_MODE.BOXED
                                    ? PAGE_CONTAINER_MODE.BOXED
                                    : PAGE_CONTAINER_MODE.FLUID
                                }
                                onChange={(v) => setConfig('pageContainerMode', v)}
                                options={[
                                  { label: 'Fluid', value: PAGE_CONTAINER_MODE.FLUID },
                                  { label: 'Boxed', value: PAGE_CONTAINER_MODE.BOXED },
                                ]}
                              />
                            </div>
                          ),
                          onClick: (e) => e.domEvent.stopPropagation(),
                        },
                        { type: 'divider' },
                        {
                          key: 'footer-tools',
                          icon: <ToolOutlined />,
                          label: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 12 }}
                            >
                              <span>Advanced Tools</span>
                              <Switch
                                size="small"
                                checked={showFooterTools}
                                onChange={handleFooterToolsChange}
                              />
                            </div>
                          ),
                          onClick: (e) => e.domEvent.stopPropagation(),
                        },
                      ],
                    }}
                    trigger={['click']}
                    placement="bottomLeft"
                    getPopupContainer={(triggerNode) => triggerNode?.parentElement ?? document.body}
                  >
                    <Button
                      // color="default"
                      // variant="filled"
                      type="text"
                      className="w-100 p-0"
                      style={{ height: '50px', minHeight: '50px' }}
                      icon={<DownOutlined className='fs--2 fw-bold' />}
                      iconPlacement='end'
                    >
                      <div style={{ width: '180px' }}>
                       <Logo at="navbar-top" width={30} id="topLogo" />
                      </div>
                          
                    </Button>
                  </Dropdown>
                </div>
                {license_status?.type === 'trial' && (
                <Tag
                  variant="solid"
                  color="blue"
                  className='mt-1 ms-3'
                  styles={{

                  }}
                  >
                    You're using Trial mode.
                  </Tag>                
                )}
                {/* {license_status?.type === 'trial' && (
                  <div className="trial-mode-top-nav-banner-line">
                    <div className="trial-mode-top-nav-banner-box">You're using Trial mode.</div>
                  </div>
                )} */}
              </div>
            )}
          </div>
        </div>

        <div
          className="varexe-navbar-side__menu-wrap"
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollbarWidth: 'thin',
            scrollbarGutter: 'stable',
          }}
        >
          {renderMenuContent()}
        </div>
      </div>
    </Layout.Sider>
  );
};

NavbarLeft.propTypes = {
  label: PropTypes.string
};

export default connect(mapStateToProps)(NavbarLeft)
